'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { TrendingUp, TrendingDown, BarChart2, Home, Building2, MapPin } from 'lucide-react';

const MarketMiniChart = dynamic(() => import('./MarketMiniChart'), { ssr: false });

const MARKET_DATA = [
  {
    id: 'stat-istanbul-satilik',
    city: 'İstanbul',
    type: 'Satılık Ortalama m²',
    value: '₺87.450',
    unit: '/m²',
    change: '+12.4%',
    positive: true,
    icon: <Building2 size={18} />,
    color: 'text-primary',
    bgColor: 'bg-primary-light',
    data: [72, 74, 76, 79, 80, 82, 85, 87],
  },
  {
    id: 'stat-istanbul-kiralik',
    city: 'İstanbul',
    type: 'Kiralık Ortalama',
    value: '₺38.200',
    unit: '/ay',
    change: '+8.7%',
    positive: true,
    icon: <Home size={18} />,
    color: 'text-accent',
    bgColor: 'bg-orange-50',
    data: [31, 32, 33, 34, 35, 36, 37, 38],
  },
  {
    id: 'stat-ankara-satilik',
    city: 'Ankara',
    type: 'Satılık Ortalama m²',
    value: '₺42.300',
    unit: '/m²',
    change: '+9.1%',
    positive: true,
    icon: <Building2 size={18} />,
    color: 'text-success',
    bgColor: 'bg-success-light',
    data: [34, 35, 36, 37, 38, 39, 41, 42],
  },
  {
    id: 'stat-izmir-satilik',
    city: 'İzmir',
    type: 'Satılık Ortalama m²',
    value: '₺68.750',
    unit: '/m²',
    change: '-2.3%',
    positive: false,
    icon: <MapPin size={18} />,
    color: 'text-danger',
    bgColor: 'bg-danger-light',
    data: [74, 73, 72, 71, 70, 70, 69, 68],
  },
  {
    id: 'stat-antalya-kira',
    city: 'Antalya',
    type: 'Kira Getirisi',
    value: '%6.2',
    unit: 'brüt',
    change: '+0.4%',
    positive: true,
    icon: <BarChart2 size={18} />,
    color: 'text-primary',
    bgColor: 'bg-primary-light',
    data: [5.4, 5.5, 5.7, 5.8, 5.9, 6.0, 6.1, 6.2],
  },
  {
    id: 'stat-mugla-satilik',
    city: 'Muğla',
    type: 'Satılık Ortalama m²',
    value: '₺124.800',
    unit: '/m²',
    change: '+18.6%',
    positive: true,
    icon: <Building2 size={18} />,
    color: 'text-accent',
    bgColor: 'bg-orange-50',
    data: [98, 103, 108, 112, 115, 118, 121, 124],
  },
];

export default function MarketStats() {
  return (
    <section className="py-12 bg-white border-b border-border">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10">
        <div className="flex items-center justify-between mb-6">
          <div>
            <p className="section-label mb-1">Piyasa Verileri</p>
            <h2 className="text-xl font-bold text-foreground">Canlı Piyasa İstatistikleri</h2>
          </div>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <div className="w-2 h-2 rounded-full bg-success animate-pulse-soft"></div>
            <span>Güncel veriler · Ağustos 2026</span>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
          {MARKET_DATA?.map((stat) => (
            <div key={stat?.id} className="card-base p-4 hover-lift">
              <div className="flex items-center justify-between mb-3">
                <div className={`w-8 h-8 rounded-lg ${stat?.bgColor} ${stat?.color} flex items-center justify-center`}>
                  {stat?.icon}
                </div>
                <span className={`text-xs font-bold flex items-center gap-0.5 ${stat?.positive ? 'text-success' : 'text-danger'}`}>
                  {stat?.positive ? <TrendingUp size={11} /> : <TrendingDown size={11} />}
                  {stat?.change}
                </span>
              </div>
              <p className="text-xs text-muted-foreground font-medium mb-0.5">{stat?.city}</p>
              <p className="text-[10px] text-muted-foreground mb-1">{stat?.type}</p>
              <p className="text-lg font-extrabold text-foreground tabular-nums leading-tight">
                {stat?.value}
                <span className="text-xs font-normal text-muted-foreground ml-1">{stat?.unit}</span>
              </p>
              <div className="mt-2 h-8">
                <MarketMiniChart data={stat?.data} positive={stat?.positive} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}